export default __webpack_public_path__ + "static/media/14.cd68d523.jpg";